// Phase 3 free-form show tuning. Style scoring -> feelings lives here (edit after rehearsal/recordings).
import { VISUAL_PALETTES } from './mycelium';

export const FEELINGS3 = ['pleasure', 'pain', 'love', 'hate', 'loneliness', 'ecstasy'];

export const FREE_CONFIG = {
  windowMs: 7000, // style scorer looks at the last 7 s
  sampleMs: 100,
  excitation: { fillPerS: 10, scoreRef: 10, pokeBonus: 6, drainPerS: 3, repeatDropTo: 60, nudge: 10 },
  longing: { delayS: 1, fillPerS: 12.5, drainPerS: 30 }, // ~8 s of stillness fills it
  // Style normalisation (relative-change z units from spore/rollingTouch.js):
  //   crowd/amount = mean sqrt(levelZ^2 + noteZ^2) over active samples, mapped crowdLo..crowdHi -> 0..1
  //   roughness    = median (actZ + 0.15 * velZ) over active samples, mapped roughLo..roughHi -> 0..1
  //   gentleness   = sustained contact ((activeFrac - 0.2) / 0.5) x (1 - roughness)
  //   sparseness   = pokes (short TAP onsets / pokeCount) x low duty cycle ((0.85 - activeFrac) / 0.4) x (1 - crowd)
  //   stillness    = 1 - activeFrac
  style: { crowdLo: 10, crowdHi: 16, roughLo: 3, roughHi: 9, pokeCount: 3 },
  // Feeling scores from styles:
  //   pleasure = gentleness x (1 - crowd)          (slow, gentle stroking)
  //   pain     = roughness x (1 - 0.6 crowd) x sustained x (1 - sparseness)   (fast, rough rubbing)
  //   love     = gentleness x crowd                 (long, gentle, many hands)
  //   hate     = sparseness                         (sharp pokes with pauses)
  //   loneliness = longing meter (stillness only)
  //   ecstasy  = crowd x roughness, only after the other five (everyone, everything)
  promptedBonus: 0.25,
  minWinScore: 0.12,
  repeatsToAward: 2,
  styleHoldMs: 1500, // a new dominant style must persist this long before HUD/commentary switch
  // LONELINESS can win only when prompted, or after the audience touched it since the last reveal AND >=3 of pleasure/pain/love/hate are found
  lonelinessAfterFound: 3,
  interpretEarlyMs: 1500,
  commentaryGapMs: 7000,
  styleCommentEveryMs: 14000,
  idleCommentMs: 16000,
  nobodyAfterS: 4,
  assistAfterS: 45,
  hostHintAfterS: 75,
  milestones: [30, 60, 85],
  openingMinMs: 2500,
  revealMs: 3600,
  interpretMinMs: 1500,
  analysisMs: 3000,
  analysisStampDelayMs: 1200,
  maxTalkMs: 15000,
};

export const FEELING_COLORS3 = {
  pleasure: '#ff9ec7', pain: '#ff4d4d', love: '#ff5fa2', hate: '#c6ff3d', loneliness: '#7f9cf5', ecstasy: '#ffd166',
  curiosity: '#00e5ff', fear: '#ff8a3d', jealousy: '#3dff8f', embarrassment: '#ff6f61', boredom: '#a0aab4', desire: '#d16bff',
};
export const STYLE_FEELING = { gentle: 'pleasure', rough: 'pain', crowd: 'love', pokes: 'hate', nobody: 'loneliness', frenzy: 'ecstasy' };

Object.assign(VISUAL_PALETTES, {
  pleasure: { base: [150, 60, 100], glow: [255, 158, 199], speed: 180, jitter: 1.6, breathHz: 0.14 },
  pain: { base: [150, 30, 40], glow: [255, 77, 77], speed: 430, jitter: 6, breathHz: 0.55 },
  love: { base: [140, 30, 80], glow: [255, 95, 162], speed: 150, jitter: 1.2, breathHz: 0.1 },
  hate: { base: [80, 110, 10], glow: [198, 255, 61], speed: 380, jitter: 5, breathHz: 0.45 },
  loneliness: { base: [40, 60, 110], glow: [127, 156, 245], speed: 80, jitter: 1, breathHz: 0.05 },
  ecstasy: { base: [150, 100, 20], glow: [255, 209, 102], speed: 320, jitter: 3, breathHz: 0.3, cycle: true },
  fear: { base: [150, 70, 20], glow: [255, 138, 61], speed: 430, jitter: 6, breathHz: 0.55 },
  jealousy: { base: [20, 120, 60], glow: [61, 255, 143], speed: 300, jitter: 4, breathHz: 0.35 },
  embarrassment: { base: [150, 50, 45], glow: [255, 111, 97], speed: 260, jitter: 3, breathHz: 0.3 },
  boredom: { base: [60, 66, 72], glow: [160, 170, 180], speed: 60, jitter: 0.8, breathHz: 0.04 },
  desire: { base: [110, 40, 150], glow: [209, 107, 255], speed: 200, jitter: 2, breathHz: 0.18 },
});
export const DRONE_OF = {
  pleasure: 'joy', pain: 'fear', love: 'trust', hate: 'fear', loneliness: 'grief', ecstasy: 'unity',
  curiosity: 'curiosity', fear: 'fear', jealousy: 'fear', embarrassment: 'joy', boredom: 'grief', desire: 'trust',
};
